import "whatwg-fetch"
import "cars_search/desktop"

import SearchFormContainerComponent from "../cars_search/SearchFormContainer"

export const SearchFormContainer = renderReact(
  "SearchFormContainer",
  SearchFormContainerComponent
)
